




import { Vue, Component } from 'vue-property-decorator';
import LoginRegister from '../login/LoginRegister.vue';

@Component({
    components: {
        LoginRegister
    }
})
export default class Login extends Vue {
    
}
